import * as React from 'react'
import { compiler } from 'markdown-to-jsx'
import { IProject } from '../..'
import DemoImage from './demo.jpg'

const proj: IProject = {
    id: 'bcit-progress-tracker',
    name: 'BCIT ProgressTracker',
    type: 'app',
    tags: ['chrome-extension', 'data-structures', 'analytics', 'ux', 'react', 'typescript', 'sass'],
    containsImages: true,
    containsVideos: true,
    description: (
        <>
        <p>
            Scrapes and indexes course data from student's D2L page and creates magical stats out of it. Stats include but limited to, their progression in
            current courses/programs, progression in linked programs, and a lot more.
        </p>
        <img src={DemoImage} alt='BCIT ProgressTracker demo image' style={{width: '100%'}}/>
        </>
    ),
    article: (() => {
        let compiledCache: JSX.Element
        return async () => {
            if (!compiledCache) {
                const md = await require('raw-loader!./detail.md')
                compiledCache = compiler(md) as any
            }
            return compiledCache
        }
    })(),
    links: new Map()
        .set('Chrome Webstore', 'https://chrome.google.com/webstore/detail/bcit-progresstracker/kbnklenakgjfodgloppngbnaidljgepi')
        .set('GitHub Repository', 'https://goo.gl/cj5Exo')
}

export default proj



// WEBPACK FOOTER //
// ./src/components/Projects/_projects/bcit-prog-tracker/index.tsx